export default "__VITE_ASSET__DhQ2skEX__"